import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter, Redirect } from "react-router-dom";
import { graphql, compose, withApollo } from "react-apollo";
import gql from "graphql-tag";
import { signInAction, signOutAction } from "../../actions/auth_actions";
import { toast } from "react-toastify";
import { Box } from "reflexbox";
import { TextField } from "office-ui-fabric-react/lib/TextField";
import { PrimaryButton } from "office-ui-fabric-react/lib/Button";
import { authUpdateAction } from "../../actions/auth_actions";

import Background from "../../images/leaves.jpg";

class Login extends Component {
  constructor() {
    super();

    this.state = {
      email: "",
      password: "",
    };
  }

  handleChange = (name, value) => {
    let newState = {};
    newState[name] = value;
    this.setState(newState);
  };

  handleSubmit = () => {
    const { email, password } = this.state;
    this.props
      .signinRelation({ variables: { email, password } })
      .then(response => {
        this.props.signIn(response.data.authenticate.jwtToken);
        this.props.client
          .query({
            query: currentRelation,
          })
          .then(response => {
            this.props.authUpdate(
              response.data.currentRelation.name,
              response.data.currentRelation.role,
              response.data.currentRelation.id
            );
            toast.success(`You are logged in as ${response.data.currentRelation.role}!`);
            if (response.data.currentRelation.role === "seller") this.props.history.push("seller");
            else this.props.history.push("planning");
          })
          .catch(err => {
            this.props.signOut();
            toast.error(`${err}`);
          });
      })
      .catch(err => {
        this.props.signOut();
        toast.error(`${err}`);
      });
  };

  render() {
    const { from } = this.props.location.state || { from: { pathname: "/" } };
    if (this.props.authenticated) {
      return <Redirect to={from} />;
    }
    return (
      <div
        // style={{
        //   backgroundImage: `url(${Background})`,
        //   height: "calc(100% - 50px)",
        //   width: "100%",
        //   backgroundSize: "cover",
        // }}
      >
        <Box flex justify="space-around" align="center">
          <Box w={[1, 1 / 2, 1 / 4]} mt={4}>
            <TextField
              onChanged={value => this.handleChange("email", value)}
              name="email"
              label="Email"
              placeholder="username or email"
              iconProps={{ iconName: "Mail" }}
            />
            <TextField
              onChanged={value => this.handleChange("password", value)}
              placeholder="password"
              type="password"
              label="Password"
              iconProps={{ iconName: "Unlock" }}
            />
            <Box flex mt={3} align="center" justify="space-between">
              <PrimaryButton onClick={this.handleSubmit} text="Login" />
            </Box>
          </Box>
        </Box>
      </div>
    );
  }
}

const signinRelation = gql`
  mutation($email: String!, $password: String!) {
    authenticate(input: { email: $email, password: $password }) {
      jwtToken
    }
  }
`;

const currentRelation = gql`
  query currentRelation {
    currentRelation {
      id
      name
      role
    }
  }
`;

export default withApollo(
  withRouter(
    compose(
      connect(state => state.auth, {
        signIn: signInAction,
        signOut: signOutAction,
        authUpdate: authUpdateAction,
      }),
      graphql(signinRelation, { name: "signinRelation" })
    )(Login)
  )
);



// WEBPACK FOOTER //
// ./src/views/App/Login.js